import { Component, OnInit, Input } from '@angular/core';
import { FilterService } from '../Services';

@Component({
  selector: 'cmat-thbtns',
  templateUrl: './t_thbtns.component.html',
  styleUrls: ['./thbtns.component.less']
})
export class ThbtnsComponent implements OnInit {

  @Input('filterService') filterService:FilterService;
  @Input('prop') prop:string = null;
  @Input('subObject') subObject:string = null;

  @Input('showOrder') showOrder:boolean = true;
  @Input('showFilter') showFilter:boolean = true;


  constructor() { }

  ngOnInit() {
  }

}
